module.exports = __webpack_public_path__ + "media/customizations/woodlandshills/back-e95b690e324a9283478a4fed9d026d44.jpg";